<template>
  <Hero :title="data?.header.title" :subtitle="data?.header.subtitle" :padded="true" :narrow="true" :images="data?.header.images"/>
  <div class="overhanging maxw--neck">
    <AlbumCard v-if="albums?.length && albums.length > 0" :data="albums[0]" :slide="true"/>
    <div class="album card" v-else-if="albumsFetching">
      <div class="album__thumbnail album__placeloader">
        <Spinner color="#0043A0" class="animate-spin--xxl" backspin-color="#f9fbfd"/>
      </div>
    </div>
  </div>
  <main class="main maxw--body grid--two mb-2 mt-2">
    <div v-for="album in albums?.filter((_, i) => i >= 1)" :key="album.id">
      <AlbumCard :data="album"/>
    </div>
  </main>
</template>

<script lang="ts" setup>
import AlbumsPage from '~/typings/pages/albums_page';
import Album from '~/typings/items/album';

useHead({
  title: 'Albums'
});

const { findOne, find } = useStrapi();
const user = useStrapiUser();

const { data } = await useAsyncData(
  'albumspage',
  () => findOne<AlbumsPage>('albums-page', { populate: ['header', 'header.images'] }),
  {
    transform: flattenStrapiObject
  }
);

const { data: albums, pending: albumsFetching } = await useAsyncData(
  'albums',
  () => find<Album>('albums', { populate: ['images'], sort: 'publishedAt:desc' }),
  {
    transform: flattenStrapiCollection,
    lazy: true,
    server: false,
    watch: [user]
  }
)
</script>
